import * as React from "react";
import { forwardRef, memo } from "react";
const SvgDropdown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12.1376 6.0287L7.99951 1.89062L3.86143 6.0287L4.80423 6.9715L7.99951 3.77625L11.1948 6.9715L12.1376 6.0287ZM3.86133 9.97163L7.99938 14.1097L12.1374 9.97163L11.1946 9.02883L7.99938 12.2241L4.80413 9.02883L3.86133 9.97163Z", fill: "#2F2F2F" }));
const ForwardRef = forwardRef(SvgDropdown);
const Memo = memo(ForwardRef);
export default Memo;
